import { createContext, useContext, useState, useCallback, useRef, useEffect } from 'react';
import { useURLParams } from './ParamsContext';

const NoticeContext = createContext();

export const NoticeProvider = ({ children }) => {
    const { params } = useURLParams();
    const [notice, setNotice] = useState({
        visible: false,
        message: '',
        status: 'success',
    });

    const timeoutRef = useRef(null);

    const hideNotice = useCallback(() => {
        setNotice((prev) => ({ ...prev, visible: false }));
    }, []);

    const showNotice = useCallback((message, status = 'success') => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        setNotice({ visible: true, message, status });

        timeoutRef.current = setTimeout(() => {
            hideNotice();
        }, 3000);
    }, [hideNotice]);

    // Clean up timeout on unmount
    useEffect(() => {
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);

    // Clear notice whenever 'view' param changes
    useEffect(() => {
        hideNotice();
    }, [params?.view]);

    return (
        <NoticeContext.Provider value={{ notice, showNotice, hideNotice }}>
            {children}
        </NoticeContext.Provider>
    );
};

export const useNotice = () => useContext(NoticeContext);
